module.exports = __webpack_public_path__ + "static/media/icon_outlink.242dcd17.svg";